import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions } from "@reporting/rp-app-host";
import { EmailLogEntity } from "@reporting/rp-types/accounting";

const PAGE_SIZE = 500;

export class EmailLogGridAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			data: 'server',
			header: msg('Server'),
			t: 't',
			w: 100,
		}, {
			data: 'profile',
			header: msg('Profile'),
			t: 't',
			w: 80,
		}, {
			data: 'mailitem_id',
			header: '#',
			t: 't',
			w: 80,
		}, {
			data: 'send_request_date',
			header: msg('Date'),
			t: 'dt',
			w: 145,
		}, {
			data: 'recipients',
			header: msg('Recipients'),
			t: 't',
			w: 200,
		}, {
			data: 'subject',
			header: msg('Subject'),
			t: 't',
			w: 200,
		}, {
			data: 'file_attachments',
			header: msg('Files'),
			t: 't',
			w: 200,
		}, {
			data: 'sent_status',
			header: msg('Status'),
			t: 't',
			w: 80,
		}, {
			data: 'error',
			header: msg('Error'),
			t: 't',
			w: 300,
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		const logs = await rp.ms('accounting').get<EmailLogEntity[]>(`/auto/emailLog`, this.createRequestParams(filters, {
			count: PAGE_SIZE,
		}));
		return logs.map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: PAGE_SIZE,
			editable: false,
			lightTheme: null,
			darkTheme: null,
			toolbar: {
				autoUpdate: {enabled: true},
				save: {enabled: false},
				discard: {enabled: false},
				new: {enabled: false},
			},
		});
	}

}
